import BaseDialog from "@/components/BaseDialog";

// 产品详情预览 弹窗
export function previewTableModal({ props, cbs,on }) {
    return new BaseDialog({
        component: ()=>import('./previewTableModal.vue'),
        options: {
            width: '70%',
            title: props.title,
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
        on,
    })
}


// 添加媒体 弹窗
export function addPlatModal({ props, cbs,on }) {
    return new BaseDialog({
        component: ()=>import('./addPlatModal.vue'),
        options: {
            width: '600px',
            title: props.title,
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
        on,
    })
}
